import React from 'react'

import { ErrorBoundary } from 'app/ErrorBoundaries'

export const catchAppErrors = (children) => <ErrorBoundary app>{children}</ErrorBoundary>
export const catchComponentErrors = (children) => <ErrorBoundary>{children}</ErrorBoundary>
